import req from './request'

const DEFAULT_ENDPOINTS = {
    list: '/sos',
    view: '/sos/',
    update: '/sos/',
    sendTelegram: '/sos/:id/send-telegram'
}

export default {
    list(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.list, param)
    },
    view(payload, param, method) {
        const id = payload.id || param.id
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.view + id, param)
    },
    update(payload, param, method) {
        const id = payload.id || param.id
        const updatePayload = { ...payload }
        delete updatePayload.id
        return req[method || 'put'](updatePayload, DEFAULT_ENDPOINTS.update + id, param)
    },
    sendTelegram(payload, param, method) {
        const id = payload.id || param.id
        const endpoint = DEFAULT_ENDPOINTS.sendTelegram.replace(':id', id)
        return req[method || 'post'](payload, endpoint, param)
    }
}
